import { WifiOff, RefreshCw, Cloud, CloudOff } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useOfflineSync } from '@/hooks/useOfflineSync';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export const OfflineIndicator = () => {
  const { isOnline, isSyncing, pendingCount, lastSyncTime, syncPendingChanges } = useOfflineSync();

  if (isOnline && pendingCount === 0) {
    return null;
  }

  return (
    <TooltipProvider>
      <div className="fixed bottom-4 right-4 z-50 flex items-center gap-2">
        {!isOnline && (
          <Badge variant="destructive" className="flex items-center gap-1.5 px-3 py-1.5">
            <WifiOff className="h-3.5 w-3.5" />
            <span>Offline</span>
          </Badge>
        )}
        
        {pendingCount > 0 && (
          <Tooltip>
            <TooltipTrigger asChild>
              <Badge 
                variant={isOnline ? "secondary" : "outline"} 
                className="flex items-center gap-1.5 px-3 py-1.5 cursor-pointer"
                onClick={() => isOnline && !isSyncing && syncPendingChanges()}
              >
                {isSyncing ? (
                  <RefreshCw className="h-3.5 w-3.5 animate-spin" />
                ) : isOnline ? (
                  <Cloud className="h-3.5 w-3.5" />
                ) : (
                  <CloudOff className="h-3.5 w-3.5" />
                )}
                <span>{pendingCount} pending</span>
              </Badge>
            </TooltipTrigger>
            <TooltipContent>
              <p>
                {isSyncing 
                  ? 'Syncing changes...' 
                  : isOnline 
                    ? 'Click to sync now' 
                    : 'Will sync when back online'}
              </p>
              {lastSyncTime && (
                <p className="text-xs text-muted-foreground">
                  Last sync: {lastSyncTime.toLocaleTimeString()}
                </p>
              )}
            </TooltipContent>
          </Tooltip>
        )}
      </div>
    </TooltipProvider>
  );
};
